<template>
  <div :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content">
        <HelperNav />
          <div class="dashboard-wrapper">

            <div class="ar-card">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  تاریخچه مبادلات
                  <i class="mdi mdi-information-outline popover-activator" tabindex="1">
                    <div class="ar-popover">
                       کاربر گرامی, تمامی مبادلات خود در همه ی قسمت ها را دراین بخش مشاهده نمایید. برای مشاهده تاریخچه هر قسمت از فیلتر ها استفاده کنید.
                    </div>
                  </i> 
                </div>
                <span></span>
              </div>
              <div class="ar-card-body">

                <div class="row">
                  <div class="col-xl-8 col-md-6 col-sm-12"></div>
                  <div class="col-xl-4 col-md-6 col-sm-12">

                    <div class="ar-form-group">
                      <select class="ar-form-control" v-model="active_tab">
                        <option value="buy">خرید ها</option>
                        <option value="sell">فروش ها</option>
                        <option value="deposit">واریز ها</option>
                        <option value="withdraw">برداشت ها</option>
                        <option value="convert">تبدیلات</option>
                      </select>
                    </div>

                  </div>
                </div>

                <div v-if="!Object.keys(histories).length" class="p-4 text-center">هنوز درخواستی ایجاد نشده است.</div>

                <div v-if="active_tab === 'buy'" class="table-responsive">
                  <table class="table ar-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>مقدار واریزی</th>
                        <th>میزان دریافتی</th>
                        <th>وضعیت درخواست</th>
                        <th>زمان</th>
                        <th>جزئیات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item , key) in histories" :key="key">
                        <td>{{ key+1 }}</td>
                        <td>
                          <template v-if="item.paid_currency == 'IRR'">
                            {{formatPrice(item.paid_amount)}} تومان 
                          </template>
                          <template v-else>
                            <bdi>{{item.paid_amount}} {{item.paid_currency}} </bdi>
                          </template>
                        </td>

                        <td>
                          <template v-if="item.received_currency == 'USDT'">
                            {{ item.received_amount }} تتر 
                          </template>
                          <template v-else>
                            <bdi>{{item.received_amount}} {{item.received_currency}} </bdi>
                          </template>
                        </td>
                        <td>
                          <span class="text-warning" v-if="item.status == 0">در حال بررسی</span>
                          <span class="text-success" v-if="item.status == 1">انجام شده</span>
                          <span class="text-danger" v-if="item.status == 2">رد شده</span>
                          <span class="text-primary" v-if="item.status == 3">در حال ارسال</span>
                        </td>
                        <td>
                          {{item.registered_at}}
                        </td>
                        <td>
                          <span :class="[
                              (item.status == 0 ? 'text-warning' : ''),
                              (item.status == 1 ? 'text-success' : ''),
                              (item.status == 2 ? 'text-danger' : ''),
                              (item.status == 3 ? 'text-primary' : '')
                            ]"
                          >
                            <router-link :to="{name:'ExchangeDetails' , params:{id:item.uuid}}">
                              <i class="mdi mdi-information-outline"></i>
                            </router-link>
                          </span>

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="active_tab === 'sell'" class="table-responsive">
                  <table class="table ar-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>میزان واریزی</th>
                        <th>مقدار دریافتی</th>
                        <th>وضعیت درخواست</th>
                        <th>زمان</th>
                        <th>جزئیات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item , key) in histories" :key="key">
                        <td>{{ key+1 }}</td>
                        <td>
                          <template v-if="item.paid_currency == 'USDT'">
                            {{ item.paid_amount }} تتر 
                          </template>
                          <template v-else>
                            <bdi>{{item.paid_amount}} {{item.paid_currency}} </bdi>
                          </template>
                        </td>
                        <td>
                          <template v-if="item.received_currency == 'USDT'">
                            {{ item.received_amount }} تتر 
                          </template>
                          <template v-if="item.received_currency == 'IRR'">
                            {{formatPrice(item.received_amount)}} تومان
                          </template>
                        </td>
                        <td>
                          <span class="text-warning" v-if="item.status == 0">در حال بررسی</span>
                          <span class="text-success" v-if="item.status == 1">انجام شده</span>
                          <span class="text-danger" v-if="item.status == 2">رد شده</span>
                          <span class="text-primary" v-if="item.status == 3">در حال واریز</span>
                          <span class="text-primary" v-if="item.status == 4">در حال واریز</span>
                        </td>
                        <td>
                          {{item.registered_at}}
                        </td>
                        <td>
                          <span :class="[
                              (item.status == 0 ? 'text-warning' : ''),
                              (item.status == 1 ? 'text-success' : ''),
                              (item.status == 2 ? 'text-danger' : ''),
                              (item.status == 3 ? 'text-primary' : '')
                            ]"
                          >
                            <router-link :to="{name:'ExchangeDetails' , params:{id:item.uuid}}">
                              <i class="mdi mdi-information-outline"></i>
                            </router-link>
                          </span>

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="active_tab === 'deposit'" class="table-responsive">
                  <table class="table ar-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>مقدار واریزی</th>
                        <th>وضعیت درخواست</th>
                        <th>زمان</th>
                        <th>جزئیات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item , key) in histories" :key="key">
                        <td>{{ key+1 }}</td>
                        <td>
                          <template v-if="item.paid_currency == 'USDT'">
                            {{ item.paid_amount }} تتر 
                          </template>
                          <template v-if="item.paid_currency == 'IRR'">
                            {{formatPrice(item.paid_amount)}} تومان
                          </template>
                        </td>
                        <td>
                          <span class="text-warning" v-if="item.status == 0">در حال بررسی</span>
                          <span class="text-success" v-if="item.status == 1">تایید شده</span>
                          <span class="text-danger" v-if="item.status == 2">رد شده</span>
                        </td>
                        <td>
                          {{item.registered_at}}
                        </td>
                        <td>
                          <span :class="[
                              (item.status == 0 ? 'text-warning' : ''),
                              (item.status == 1 ? 'text-success' : ''),
                              (item.status == 2 ? 'text-danger' : '')
                            ]"
                          >
                            <router-link :to="{name:'ExchangeDetails' , params:{id:item.uuid}}">
                              <i class="mdi mdi-information-outline"></i>
                            </router-link>
                          </span>

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="active_tab === 'withdraw'" class="table-responsive">
                  <table class="table ar-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>مقدار برداشتی</th>
                        <th>وضعیت درخواست</th>
                        <th>زمان</th>
                        <th>جزئیات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item , key) in histories" :key="key">
                        <td>{{ key+1 }}</td>
                        <td>
                          <template v-if="item.received_currency == 'USDT'">
                            {{ item.received_amount }} تتر 
                          </template>
                          <template v-if="item.received_currency == 'IRR'">
                            {{formatPrice(item.received_amount)}} تومان
                          </template>
                        </td>
                        <td>
                          <span class="text-warning" v-if="item.status == 0">در حال بررسی</span>
                          <span class="text-success" v-if="item.status == 1">تایید شده</span>
                          <span class="text-danger" v-if="item.status == 2">رد شده</span>
                        </td>
                        <td>
                          {{item.registered_at}}
                        </td>
                        <td>
                          <span :class="[
                              (item.status == 0 ? 'text-warning' : ''),
                              (item.status == 1 ? 'text-success' : ''),
                              (item.status == 2 ? 'text-danger' : '')
                            ]"
                          >
                            <router-link :to="{name:'ExchangeDetails' , params:{id:item.uuid}}">
                              <i class="mdi mdi-information-outline"></i>
                            </router-link>
                          </span>

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="active_tab === 'convert'" class="table-responsive">
                  <table class="table ar-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>مقدار تبدیل</th>
                        <th>میزان محاسبه شده</th>
                        <th>زمان</th>
                        <th>جزئیات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item , key) in histories" :key="key">
                        <td>{{ key+1 }}</td>
                        <td>
                          <template v-if="item.paid_currency == 'IRR'">
                            {{formatPrice(item.paid_amount)}} تومان 
                          </template>
                          <template v-else>
                            <bdi>{{item.paid_amount}} {{item.paid_currency}} </bdi>
                          </template>
                        </td>

                        <td>
                          <template v-if="item.received_currency == 'IRR'">
                            {{formatPrice(item.received_amount)}} تومان 
                          </template>
                          <template v-else>
                            <bdi>{{item.received_amount}} {{item.received_currency}} </bdi>
                          </template>
                        </td>
                        <td>
                          {{item.registered_at}}
                        </td>
                        <td>
                          <span :class="[
                              (item.status == 0 ? 'text-warning' : ''),
                              (item.status == 1 ? 'text-success' : ''),
                              (item.status == 2 ? 'text-danger' : ''),
                              (item.status == 3 ? 'text-primary' : '')
                            ]"
                          >
                            <router-link :to="{name:'ExchangeDetails' , params:{id:item.uuid}}">
                              <i class="mdi mdi-information-outline"></i>
                            </router-link>
                          </span>

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>

            </div>
            
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import HelperNav from './partials/HelperNav'
import {TheMask} from 'vue-the-mask'
export default {
  name: 'Records',
  components:{
    Sidebar,
    Header,
    HelperNav,
    TheMask
  },
  data : () => ({
    loading:false,
    active_tab:'buy',
    histories:[],
    data:{},
  }),
  computed:{
    buy_filter() {
      return this.histories.filter( item => {
        return item.type === 'buy'
      })
    },
    sell_filter() {
      return this.histories.filter( item => {
        return item.type === 'sell'
      })
    },
    deposit_filter() {
      return this.histories.filter( item => {
        return item.type === 'deposit'
      })
    },
    withdraw_filter() {
      return this.histories.filter( item => {
        return item.type === 'withdraw'
      })
    },
  },
  watch:{
    active_tab(){
      this.getHistories()
    }
  },
  methods:{
    getHistories(){
      this.activeLoading(true)
      const api_token = this.getToken()
      
      this.$axios.post(`exchangesHistory`,{type:this.active_tab},
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.histories = res.data.data
        this.activeLoading(false)
      })
      .catch(err => {
        this.activeLoading(false)
      });

    },
  },
  mounted() {
    this.activeLoading(false)
    this.checkAuth()
    this.getHistories()

  }
}
</script>
<style >
.custom{
  font-size: 18px !important;
  padding: 12px 32px !important;
}
</style>